import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Soap from '../images/soap.webp';
import QRImage from "../images/paymentQrCode.webp";
import './OrderPage.css'; // Import the CSS for styling
import { useNavigate } from 'react-router-dom';

import { useSelector } from 'react-redux';
const OrderPage = () => {
  const navigate = useNavigate();
  const productState = useSelector((state) => state.products);
  const { products } = productState;
  const { productId } = useParams(); // Get product ID from URL
  const [product, setProduct] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [totalPrice, setTotalPrice] = useState(0);
  const [address, setAddress] = useState({
    userName: "",
    phone: "",
    landmark: '',
    city: '',
    pinCode: '',
    state: ''
  });
  const [showConfirmation, setShowConfirmation] = useState(false); // To show confirmation modal
  const [confirmationData, setConfirmationData] = useState(null); // To store the confirmation data
  const [showPopup, setShowPopup] = useState(false); // To control the success or failure pop-up
  const [popupMessage, setPopupMessage] = useState(''); // Message for success/failure pop-up
  const [popupType, setPopupType] = useState('success'); // Type of pop-up (success or error)
  const [priceMSG, setPriceMSG] = useState({
    price: "",
    MSG: ""
  });

  const fetchProduct = () => {
    const foundProduct = products.find((item) => item._id == productId);

    if (foundProduct) {
      setProduct(foundProduct);
      setTotalPrice((foundProduct.offerPrice * quantity))
      setLoading(false);
    } else {
      setError('Product not found');
      setLoading(false);
    }
  };

  // Fetch product details from products data (or API)
  useEffect(() => {
    if (productId.length > 0) {
      fetchProduct();
    }
  }, [productId]);
  function setUser() {
    const user = JSON.parse(localStorage.getItem("userDetails"));
    if (user) {
      setAddress({ ...address, userName: user.name, phone: user.phone });
    }
  }

  useEffect(() => {
    setUser()
  }, []);
  useEffect(() => {
    if (totalPrice < 500) {
      setPriceMSG({ ...priceMSG, price: totalPrice + 40, MSG: `(item price - ₹${totalPrice} + ₹40 delivery charge (to get free delivery order minimum ₹500))` })
    } else {
      setPriceMSG({ ...priceMSG, price: totalPrice, MSG: "" })
    }
  }, [totalPrice]);


  // Handle address and quantity changes
  const handleChange = (e) => {
    setAddress({ ...address, [e.target.name]: e.target.value });
  };

  // Handle order confirmation modal display
  const handleConfirmOrder = () => {
    var currPrice = totalPrice;
    if (totalPrice < 500) {
      currPrice += 40;
    }

    const orderDetails = {
      userName: address.userName,
      phone: address.phone,
      itemName: product.name,
      price: currPrice,
      quantity,
      landmark: address.landmark,
      city: address.city,
      state: address.state,
      pinCode: address.pinCode
    };

    setConfirmationData(orderDetails);
    setShowConfirmation(true); // Show confirmation modal
  };

  // Handle the final submission to the backend after confirmation
  const handleSubmit = async () => {
    const currOrder = {
      ...confirmationData,
      paymentStatus: "Pending"
    }

    try {
      const response = await fetch("https://swarna-herbal-backend.onrender.com/api/orders/add-order", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(currOrder),
      });

      if (response.ok) {
        setAddress({
          userName: "",
          phone: "",
          landmark: '',
          city: '',
          pinCode: '',
          state: ''
        });
        setShowConfirmation(false); // Close the confirmation modal
        setPopupType('success');
        setPopupMessage('Your order is pending, please complete the payment to confirm your order. Send the receipt to this WhatsApp number: +917828215766');
        setShowPopup(true); // Show success pop-up
        // setTimeout(() => {
        //   setShowPopup(false);
        //   navigate("/swarnaherbalproducts");
        // }, 5000);
      } else {
        const error = await response.json();
        setPopupType('error');
        setPopupMessage(`Error placing order: ${error.message}`);
        setShowPopup(true); // Show error pop-up
      }
    } catch (error) {
      setPopupType('error');
      setPopupMessage(`Request failed: ${error.message}`);
      setShowPopup(true); // Show error pop-up
    }
  };

  // Validation checks for form
  const validateForm = () => {
    const phoneRegex = /^[6-9]\d{9}$/; // Ensure phone starts with 6, 7, 8, or 9 and has 10 digits
    const pinCodeRegex = /^\d{6}$/; // Ensure pinCode is 6 digits
    const nameRegex = /^[A-Za-z ]{1,25}$/; // Ensure name has a max length of 25 characters

    if (!nameRegex.test(address.userName)) {
      alert("Name should be up to 25 characters long.");
      return false;
    }

    if (!phoneRegex.test(address.phone)) {
      alert("Phone number should be 10 digits long and start with 6, 7, 8, or 9.");
      return false;
    }

    if (!pinCodeRegex.test(address.pinCode)) {
      alert("Pincode should be exactly 6 digits.");
      return false;
    }

    return true;
  };

  if (loading) {
    return <p>Loading product details...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }


  return (
    <div className="order-page">
      {product && (
        <div className="order-container">
          <div className="order-product-details">
            <img
              src={`https://swarna-herbal-backend.onrender.com/uploads/${product.image}`}
              alt={product.name}
              className="order-product-image"

            />
            <div className="order-product-info">
              <h3>{product.name}</h3>
              <p>{product.fullDescription}</p>
              {/* <p className="order-price">Price - &#8377;{product.price}</p> */}
              <p className="order-price">Offer Price - &#8377;{product.offerPrice}</p>
            </div>
          </div>

          <form onSubmit={(e) => { e.preventDefault(); if (validateForm()) handleConfirmOrder(); }} className="order-form">
            <div>
              <label>Quantity:</label>
              <input
                type="number"
                min="1"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                required
              />
            </div>

            <div>
              <label>Your Name:</label>
              <input
                type="text"
                name="userName"
                value={address.userName}
                onChange={handleChange}
                maxLength="25"
                required
              />
            </div>

            <div>
              <label>Phone Number:</label>
              <input
                type="tel"
                name="phone"
                value={address.phone}
                onChange={handleChange}
                pattern="[6-9]{1}[0-9]{9}"
                title="Invalid Phone Number"
                required
              />
            </div>

            <div>
              <label>Landmark:</label>
              <input
                type="text"
                name="landmark"
                value={address.landmark}
                onChange={handleChange}
                maxLength="50"
                required
              />
            </div>

            <div>
              <label>City:</label>
              <input
                type="text"
                name="city"
                value={address.city}
                onChange={handleChange}
                minLength="3"
                maxLength="20"
                required
              />
            </div>

            <div>
              <label>State:</label>
              <input
                type="text"
                name="state"
                value={address.state}
                onChange={handleChange}
                minLength="3"
                maxLength="20"
                required
              />
            </div>

            <div>
              <label>Pincode:</label>
              <input
                type="text"
                name="pinCode"
                value={address.pinCode}
                onChange={handleChange}
                pattern="\d{6}"
                title="Pincode should be exactly 6 digits"
                required
              />
            </div>

            <button type="submit" className="order-submit-btn">
              Place Order
            </button>
          </form>
        </div>
      )}

      {/* Confirmation Modal */}
      {showConfirmation && (
        <div className="confirmation-modal">
          <div className="confirmation-modal-content">
            <h3>Please confirm your details</h3>
            <p><strong>Name:</strong> {confirmationData.userName}</p>
            <p><strong>Phone:</strong> {confirmationData.phone}</p>
            <p><strong>Address:</strong> {confirmationData.landmark}, {confirmationData.city}, {confirmationData.state} - {confirmationData.pinCode}</p>
            <p><strong>Product:</strong> {confirmationData.itemName}</p>
            <p><strong>Quantity:</strong> {confirmationData.quantity}</p>
            <p><strong>Total Price:</strong> &#8377;{priceMSG.price} {priceMSG.MSG}</p>
            <div className='confirm-btn-container'>
              <button onClick={handleSubmit}>Confirm Order</button>
              <button className="cancel-btn" onClick={() => setShowConfirmation(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {showPopup && (
        <div className="confirmation-modal">
          <div className="popup">
            <div className="popup-content">
              <h3>Your Order is Pending</h3>
              <h4>Make Payment To Confirm Your Order</h4>
              <p><strong>Total Amount:</strong> &#8377;{priceMSG.price} {priceMSG.MSG}</p>

              {/* Centered QR Code */}
              <h3><strong>Name:</strong> Sona Bhadoriya</h3>
              <div className="qr-code-container">

                <img src={QRImage} alt="QR Code" className="qr-code" />
              </div>
              <p style={{ width: "100%", textAlign: "center" }}>Or</p>

              {/* UPI ID with owner name */}
              <p><strong>UPI PhonePay/GooglePay:</strong> 7828215766</p>


              {/* Payment Instructions */}
              <p><strong>Important:</strong> After completing the payment, please send the payment receipt to the same number with which your order was placed WhatsApp on this number: 7828215766.</p>

              <button className="close-btn" onClick={() => { setShowPopup(false); navigate("/my-orders") }}>Close</button>
            </div>
          </div>
        </div>

      )}

    </div>
  );
};

export default OrderPage;
